module.exports = __webpack_public_path__ + "img/all.cdb38c4b.png";